import styled from 'styled-components';
import { rgba } from 'polished';

export const Container = styled.form`
  .upload-dropzone {
    min-height: 136px;
    border: 1px dashed ${(props) => props.theme.$primary};
    border-radius: 4px;
    background: ${(props) => rgba(props.theme.$primary, 0.1)};
    color: ${(props) => props.theme.$primary};

    &:hover,
    &.is-dragging {
      background: ${(props) => rgba(props.theme.$primary, 0.18)};
    }

    .material-icons {
      font-size: 20px;
    }
  }
`;
